import React from "react";
import Radio from "antd/lib/radio";
import Form, { FormInstance } from "antd/lib/form";
import { AppButton } from "components/button";
import { ButtonType } from "components/button/appButton";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface PassedAKidneyStoneSectionProps {
  readonly currentPage: number;
  readonly form: FormInstance;
  setShowSubmit(show: boolean): void;
}

export const PassedAKidneyStoneSection: React.FC<
  PassedAKidneyStoneSectionProps
> = ({ currentPage, form, setShowSubmit }) => {
  return (
    <>
      {currentPage === 10 && (
        <SurveyQuestionCard
          sectionTag="KIDNEY STONE"
          title="Have you ever passed a kidney stone?"
          required
        >
          <FormItemStyle
            name="Have you ever passed a kidney stone"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouPassedAKidneyStone")}
              onChange={e => {
                if (e.target.value === "No") {
                  setShowSubmit(true);
                } else {
                  setShowSubmit(false);
                }
                localStorage.setItem(
                  "haveYouPassedAKidneyStone",
                  e.target.value
                );
              }}
            >
              <AnswerList>
                <AnswerOption value="Yes">Yes</AnswerOption>
                <AnswerOption value="No">No</AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}

      {currentPage === 11 && (
        <SurveyQuestionCard
          sectionTag="PASSAGE OF KIDNEY STONES"
          title="How long ago did you pass your stone?"
        >
          <FormItemStyle
            name="How long ago did you pass your stone"
            label=""
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("howLongAgoPassedStone")}
              onChange={e =>
                localStorage.setItem("howLongAgoPassedStone", e.target.value)
              }
            >
              <AnswerList>
                <AnswerOption value="In the last 2 weeks">
                  In the last 2 weeks
                </AnswerOption>
                <AnswerOption value="In the last 3 months">
                  In the last 3 months
                </AnswerOption>
                <AnswerOption value="In the last 3 - 6 months">
                  In the last 3 - 6 months
                </AnswerOption>
                <AnswerOption value="More than 6 months ago">
                  More than 6 months ago
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
          <div style={{ marginTop: "12px", textAlign: "right" }}>
            <AppButton
              buttonContent={"Clear Selection"}
              type={ButtonType.Link}
              onClick={() => {
                form.setFieldsValue({
                  "How long ago did you pass your stone": ""
                });
                localStorage.setItem("howLongAgoPassedStone", "");
              }}
            />
          </div>
        </SurveyQuestionCard>
      )}
    </>
  );
};
